/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaReportType } from './servizio-mensa-report-type';


export interface ServizioMensaReportDTO { 
    id?: string;
    servizioId?: string;
    tipo?: ServizioMensaReportType;
    titolo?: string;
    descrizione?: string;
    timestamp?: string;
}



